module.exports = __webpack_public_path__ + "static/media/comment-field-bg.79bb8d3d.png";